import { BookOpenIcon } from '@heroicons/react/24/outline';
import { FlagIcon, SparklesIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { LessonType } from '../../../api/lesson';
import { useBooleanState } from '../../../hooks/index/use-boolean-state';
import AnswersToggle from './answer-toggle';
import { BehaviorFilters } from './behavior-filters';
import Dropdown from './dropdown';
import FilterButton from './filter-button';
import FilterHeader from './filter-header';
import { StatusFilters } from './status-filters';

export type FilterItem = {
  id: string;
  name: string;
  icon?: React.ReactElement;
};

const ALL_LESSONS_OPTION: LessonType = { id: 0, name: 'همه' };
const ALL_FILTERS_OPTION: FilterItem = { id: 'all', name: 'همه' };

export type FilterSectionPropsType = {
  showAllAnswers: boolean;
  toggleShowAllAnswers: () => void;
  selectedLesson: LessonType[];
  setSelectedLesson: React.Dispatch<React.SetStateAction<LessonType[]>>;
  lessonData: LessonType[];
  selectedStatus: FilterItem[];
  selectedBehaviorState: FilterItem[];
  setSelectedBehaviorState: React.Dispatch<React.SetStateAction<FilterItem[]>>;
  setSelectedStatus: React.Dispatch<React.SetStateAction<FilterItem[]>>;
  initialIsOpen: boolean;
  toggleMarked: () => void;
  marked: boolean;
};

function StudentQuestionsFilter({
  showAllAnswers,
  toggleShowAllAnswers,
  selectedLesson,
  setSelectedLesson,
  lessonData,
  selectedStatus,
  setSelectedStatus,
  selectedBehaviorState,
  setSelectedBehaviorState,
  initialIsOpen = true,
  marked,
  toggleMarked
}: FilterSectionPropsType) {
  const { value: isOpen, toggle: toggleIsOpen } = useBooleanState(initialIsOpen);
  const activeFiltersCount = selectedStatus.length + selectedBehaviorState.length;

  return (
    <div className='z-1 relative w-full rounded-md border-2 border-amber-300 bg-amber-50 shadow-sm'>
      <FilterHeader isOpen={isOpen} toggleOpen={toggleIsOpen} activeCount={activeFiltersCount} />
      <div
        className={`overflow-visible transition-all duration-500 ease-in-out ${
          isOpen ? 'max-h-[800px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className='px-4 pb-5 pt-0'>
          <div
            className='mb-4 h-px w-full bg-gradient-to-r
           from-transparent via-gray-100 to-transparent'
          />
          <div
            className='mb-5 flex flex-col items-center justify-between
           gap-3 sm:flex-row'
          >
            <Dropdown
              label='درس'
              items={lessonData}
              allItem={ALL_LESSONS_OPTION}
              selectedItems={selectedLesson}
              setSelectedItems={setSelectedLesson}
              icon={<BookOpenIcon width={16} />}
              tickSelectedItem
            />
            <AnswersToggle isActive={showAllAnswers} onToggle={toggleShowAllAnswers} />
            <FilterButton isActive={marked} name='نشان' onClick={toggleMarked} />
          </div>

          <div
            className='mb-5 flex flex-col items-center
           justify-between gap-3 sm:flex-row'
          >
            <Dropdown
              label='وضعیت'
              items={StatusFilters}
              allItem={ALL_FILTERS_OPTION}
              selectedItems={selectedStatus}
              setSelectedItems={setSelectedStatus}
              icon={<SparklesIcon width={12} className='text-amber-400' />}
            />
            <Dropdown
              label='نشانه'
              items={BehaviorFilters}
              allItem={ALL_FILTERS_OPTION}
              selectedItems={selectedBehaviorState}
              setSelectedItems={setSelectedBehaviorState}
              icon={<FlagIcon width={12} className='text-red-400' />}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentQuestionsFilter;
